import React from "react";
import getClassName from "../../utilities/getClassName";
import chevronDownIcon from "../../assets/icons/chevron-down-dark.svg";

const AircraftCardCollapsibleSection = ({
    title,
    isExpanded,
    onToggle,
    children,
    showDesktopTitle = true,
    contentClassName = "",
}) => (
    <>
        {showDesktopTitle && (
            <div className="aircraft-card-extra-content__column__title aircraft-card-extra-content__desktop-title">
                {title}
            </div>
        )}
        <button className="aircraft-card-extra-content__section-header" onClick={onToggle}>
            <span className="aircraft-card-extra-content__column__title">{title}</span>
            <img
                src={chevronDownIcon}
                alt=""
                className={getClassName([
                    "aircraft-card-extra-content__section-chevron",
                    isExpanded && "aircraft-card-extra-content__section-chevron--open",
                ])}
            />
        </button>
        <div
            className={getClassName([
                "aircraft-card-extra-content__collapsible-content",
                contentClassName,
                isExpanded && "aircraft-card-extra-content__collapsible-content--expanded",
            ])}
        >
            {children}
        </div>
    </>
);

export default AircraftCardCollapsibleSection;
